import React from 'react'
import { Logo } from 'quantic'
import { Wrapper, Bottom, Content, Spaced } from './styles'

function Footer() {
  return (
    <Wrapper>
      <Content>
        <div>
          <Logo white width="100%" />
        </div>
        <div>
          <h2>Cursos</h2>
          <ul>
            <li>Cursos e trilhas em andamento</li>
            <li>Micro-momento</li>
            <li>Todos os cursos e trilhas</li>
          </ul>
        </div>
        <div>
          <h2>Ferramentas</h2>
          <ul>
            <li>Grupo de prática</li>
            <li>Biblioteca virtual</li>
          </ul>
        </div>
        <div>
          <h2>Sobre</h2>
          <ul>
            <li>O Lit</li>
            <li>A Saint Paul</li>
            <li>FAQ</li>
          </ul>
        </div>
        <div>
          <div>
            <h2>Nos Acompanhe</h2>
            <Spaced>
              <div>Facebook</div>
              <div>Twitter</div>
              <div>Youtube</div>
              <div>Linkedin</div>
              <div>Instagram</div>
            </Spaced>
          </div>
          <div style={{ marginTop: 10 }}>
            <h2>Baixe o aplicativo</h2>
            <Spaced>
              <div style={{ padding: 3 }}>
                <img src="/assets/images/g_icon.png" alt="download do aplicativo na Google Play" />
              </div>

              <div style={{ padding: 3 }}>
                <img src="/assets/images/apple-store.png" alt="download do aplicativo na Apple Store" />
              </div>
            </Spaced>
          </div>
        </div>
      </Content>
      <Bottom>
        <div>v2.37.3</div>
        <div>Direitos de Cópia © 2017 Lit, Inc.</div>
        <div>Termos</div>
        <div>Política de Privacidade</div>
        <div>Propriedade Intelectual</div>
      </Bottom>
    </Wrapper>
  )
}

export default Footer
